<script setup lang="ts">
import { TableProps } from '~/components/cms/Table/Table.vue'

const props = defineProps<TableProps>()
</script>

<template>
  <div class="product-detail-table__table">
    <table v-if="table">
      <tbody>
        <tr v-for="(item, index) in table.rows" :key="index">
          <td v-for="(cell, cellIndex) in item.cells" :key="cellIndex">
            <TableCell v-bind="cell" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="postcss">
/*
@TODO

.product-detail-table__table {
  margin: 0 theme-spacing(4) 0 0;
  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    tr {
      height: 0.0625rem;
    }

    tr:not(:last-child) {
      border-bottom: 1px solid rgba(theme-color(mist), 0.5);
      display: table-row;
    }

    td {
      text-align: left;
      font-weight: theme-font-weight(regular);
      font-size: theme-size(3);
      color: theme-color(charcoal);
    }
  }
} */
</style>
